<template>
  <v-card v-if="user" flat>
    <v-card-title subtitle-2>
      {{lang.user_details}}
      <small
        v-if="user.status===false"
        class="red--text ml-4"
      >({{lang.disabled}})</small>
    </v-card-title>
    <v-card-text>
      <v-expansion-panels v-model="panel">
        <v-expansion-panel>
          <v-flex style="text-align:right" ma-2>
            <v-btn text color="primary" @click="changeName">{{lang.save}}</v-btn>
          </v-flex>
          <v-expansion-panel-header>
            <v-layout row wrap>
              <v-flex col-6>
                <v-text-field
                  outlined
                  :label="lang.user_name"
                  :placeholder="lang.no_name"
                  v-model="user.name"
                  @click.stop
                  class="subtitle-1"
                ></v-text-field>
              </v-flex>
              <v-flex col-6 pr-6>
                <v-text-field
                  outlined
                  :label="lang.account_name"
                  :placeholder="lang.account_name"
                  v-model="user.accountName"
                  @click.stop
                  class="subtitle-1"
                ></v-text-field>
              </v-flex>
            </v-layout>

            <template v-slot:actions>
              <v-layout column wrap>
                <span class="primary--text">{{panel!=0?lang.view_details:lang.hide_details}}</span>
                <v-icon color="primary">expand_more</v-icon>
              </v-layout>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-layout row wrap>
              <v-flex md4 xs12 pa-2>
                <span class="subtitle-1 font-weight-bold">{{lang.user_storage}}</span>
                <span
                  class="ml-4 subtitle-1"
                >{{user.accountSettings_storageStatus_totalStorageStr || 0 }} of {{adminUser.humanFileSize(user.accountSettings_conf_maxStorage)}}</span>
              </v-flex>
              <v-flex md4 xs12 pa-2>
                <span class="subtitle-1 font-weight-bold">{{lang.usedLicenses}}</span>
                <span
                  class="subtitle-1 ml-4"
                >{{this.players.length}} {{lang.of}} {{user.accountSettings_licences_licenceNo}}</span>
              </v-flex>
              <v-flex md4 xs12 pa-2>
                <span class="subtitle-1 font-weight-bold">{{ lang.user_country }}</span>
                <span
                  v-if="user.location"
                  class="subtitle-1 ml-4"
                >{{getCountry(user.location.cf_country)}}</span>
              </v-flex>
              <v-flex xs12 pa-2>
                <subUsers :subUsers="subUsers" :user="user" :email="email" />
              </v-flex>
            </v-layout>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from "vuex";
const utils = require("@/classes/utils/utils.js").Utils;
import subUsers from "./sub_users.vue";
const manage = require("./manage.js").manage;
export default {
  data() {
    return {
      panel: -1
    };
  },
  components: {
    subUsers
  },
  computed: {
    ...mapState(["lang", "adminUser"])
  },
  props: {
    user: {
      default: false
    },
    players: {
      default: false
    },
    subUsers: {
      default: false
    },
    email: {
      default: ""
    }
  },

  methods: {
    getCountry(code) {
      return utils.getCountry(code);
    },
    getTotalAmount() {
      let amount = 0;
      if (this.user.billing_account_subs != null) {
        this.user.billing_account_subs.subs.data.forEach(function(sub) {
          amount += sub.plan.amount / 100;
        });
      }

      return amount;
    },
    changeName() {
      manage.changeName(this.email, this.user.name, this.user.accountName);
    }
  }
};
</script>